import React, { useState, useContext, useEffect, useRef } from "react";

import { Button, Grid, Tab, Tabs, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import TabAvailable from "./components/TabAvailable";
import TabConfirmation from "./components/TabConfirmation";
import TabData from "./components/TabData";
import TabTypeSchedulling from "./components/TabTypeSchedulling";
import useStyles from "./styles";
import Confirm from "../Confirm";
import { RouteContext } from "../../context/router";

const SchedulingNewComponent = ({
  subRoutes,
  isLoadingTurn,
  currentTab,
  setTab,
  editingItem,
  setEditingItem,
  products,
  branches,
  plants,
  loadTypes,
  addNewSchedule,
  scheduling,
  dates,
  turns,
  confirmed,
  setConfirmed,
  holdConfigs,
  loseConfigsWhenExit,
  getDriver,
  selectedDriver,
  clients,
  transporters,
  getClientByDocument,
  loadPlantByDocumentNumber,
  loadBranchByPlant,
  loadProductsByPlant,
  loadPlants,
  clearedTurn,
  setClearedTurn,
}) => {
  const classes = useStyles();
  const history = useContext(RouteContext);
  const [alert, setAlert] = useState(false);
  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  const myRef = useRef(null);

  useEffect(() => {
    if (myRef.current) {
      myRef.current.scrollIntoView();
    }
  }, [currentTab]);

  const handleCloseConfiguration = (confirm) => {
    setAlert(false);
    if (confirm) {
      history.push("/agendamento/agendados");
    }
  };

  return (
    <div className={classes.TabNavigationCtrlFilterPanel} ref={myRef}>
      <div className={classes.navigation}>
        <Grid container spacing={3}>
          <Grid item md={10} xs={12}>
            <div>
              <Tabs
                TabIndicatorProps={{
                  style: {
                    height: "6px",
                    backgroundColor: "#658D1B",
                  },
                }}
                className={classes.navigationRoutesTabs}
                value={currentTab}
              >
                {subRoutes.map((route, index) => (
                  <Tab
                    className={classes.navigationRoutesTabsTab}
                    key={index}
                    label={`${route.title}`}
                    {...a11yProps(index)}
                  />
                ))}
              </Tabs>
            </div>
          </Grid>
          <Grid item md={2} xs={12}>
            <div className={classes.navigationControls}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                className={classes.addButton}
                data-cy="all-btn"
                id="all-btn"
                onClick={() => {
                  !loseConfigsWhenExit
                    ? history.push("/agendamento/agendados")
                    : !confirmed && setAlert(true);
                }}
              >
                Todos os Agendamentos
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
      <Box height="100%" className={classes.containers}>
        <TabTypeSchedulling
          value={currentTab}
          index={0}
          setTab={setTab}
          loadTypes={loadTypes}
          setEditingItem={setEditingItem}
          setConfirmed={setConfirmed}
          holdConfigs={holdConfigs}
        />
        <TabData
          value={currentTab}
          index={1}
          setTab={setTab}
          editingItem={editingItem}
          setEditingItem={setEditingItem}
          products={products}
          branches={branches}
          plants={plants}
          getDriver={getDriver}
          selectedDriver={selectedDriver}
          clients={clients}
          transporters={transporters}
          getClientByDocument={getClientByDocument}
          loadPlantByDocumentNumber={loadPlantByDocumentNumber}
          loadBranchByPlant={loadBranchByPlant}
          loadProductsByPlant={loadProductsByPlant}
          loadPlants={loadPlants}
        />
        <TabAvailable
          value={currentTab}
          index={2}
          setTab={setTab}
          editingItem={editingItem}
          setEditingItem={setEditingItem}
          dates={dates}
          turns={turns}
          isLoadingTurn={isLoadingTurn}
          clearedTurn={clearedTurn}
          setClearedTurn={setClearedTurn}
        />
        <TabConfirmation
          value={currentTab}
          index={3}
          setTab={setTab}
          editingItem={editingItem}
          scheduling={scheduling}
          addNewSchedule={addNewSchedule}
          confirmed={confirmed}
          setEditingItem={setEditingItem}
          holdConfigs={holdConfigs}
        />
      </Box>
      {alert && (
        <Confirm
          isOpen={true}
          okText="Sim"
          cancelText="Não"
          data-cy="confirm-modal"
          id="confirm-modal"
          handleClose={handleCloseConfiguration}
          title="Deseja abandonar configurações?"
          message="Seus dados desta configuração serão apagados"
        />
      )}
    </div>
  );
};

SchedulingNewComponent.propTypes = {
  subRoutes: PropTypes.array.isRequired,
  setTab: PropTypes.func.isRequired,
  currentTab: PropTypes.number.isRequired,
  products: PropTypes.array.isRequired,
  dates: PropTypes.array.isRequired,
  loadTypes: PropTypes.array.isRequired,
  turns: PropTypes.array,
  clients: PropTypes.array.isRequired,
  transporters: PropTypes.array.isRequired,
  getClientByDocument: PropTypes.func.isRequired,
  loadPlantByDocumentNumber: PropTypes.func.isRequired,
  loadBranchByPlant: PropTypes.func.isRequired,
  loadProductsByPlant: PropTypes.func.isRequired,
};

export default SchedulingNewComponent;
